import { benefits } from "@/mocks/membershipData";
import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";
import Icon from "@/components/feature/Icon";

export default function MembershipBenefits() {
  const { ref: headerRef, style: headerStyle } = useScrollReveal();
  const { containerRef, getItemStyle } = useStaggerReveal(benefits.length, 100);

  return (
    <section id="benefits" className="py-24 md:py-32 bg-navy-950 relative overflow-hidden">
      {/* Animated grid pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full animate-grid-move"
          style={{
            backgroundImage:
              "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
            backgroundSize: "80px 80px",
          }}
        />
      </div>

      {/* Floating orbs */}
      <div className="absolute top-[10%] left-[5%] w-48 h-48 rounded-full bg-white/[0.02] blur-3xl animate-float-1" />
      <div className="absolute bottom-[15%] right-[10%] w-64 h-64 rounded-full bg-silver-300/[0.02] blur-3xl animate-float-2" />

      <div className="relative z-10 px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div ref={headerRef} style={headerStyle} className="max-w-3xl mb-16 md:mb-20">
          <p className="text-sm font-medium tracking-[0.2em] text-silver-400 uppercase mb-3">
            Exclusive Benefits
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-5">
            會員專屬權益
          </h2>
          <p className="text-silver-300 text-base md:text-lg leading-relaxed">
            繳納會費後，您將享有以下完整權益，涵蓋活動參與、知識資源、社群交流與品牌曝光等面向。
          </p>
        </div>

        {/* Benefits grid */}
        <div ref={containerRef} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((item, idx) => (
            <div
              key={item.title}
              style={getItemStyle(idx)}
              className="group bg-white/5 backdrop-blur-sm rounded-3xl p-7 md:p-8 border border-white/10 hover:bg-white/10 hover:border-white/20 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-navy-950 transition-all duration-500">
                  <Icon className={`${item.icon} text-xl text-white group-hover:text-navy-950 transition-colors`} />
                </div>
                <span className="text-4xl font-serif font-semibold text-white/10 group-hover:text-white/20 transition-colors">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>

              <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-sm text-silver-300 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}